import { useEffect, useState } from 'react';

/**
 * SSR-safe `window.matchMedia` hook. Returns `false` on the server and during
 * the first client paint (so server and client markup agree), then reflects the
 * real match after mount. Replaces bricks-next `useMedia()` for migrated atoms
 * components, which style breakpoints via Tailwind classes but still need a JS
 * boolean for conditional rendering.
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    setMatches(mediaQueryList.matches);

    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    mediaQueryList.addEventListener('change', onChange);
    return () => mediaQueryList.removeEventListener('change', onChange);
  }, [query]);

  return matches;
};

/** bricks `useMedia().smallerThanMD` — viewport ≤ 767px (below the 768px MD breakpoint). */
export const useSmallerThanMD = (): boolean => useMediaQuery('(max-width: 767px)');
